import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { roundUpToNearestRange } from '../methods/contentFormatHelpers';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
    ChartDataLabels
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top' as const,
        },
        title: {
            display: true,
            text: 'Ksztaltowanie się wartości NPV w zależności od stopy dyskonta',
        }
    }
};

const labels = ['0%', '2%', '4%', '6%', '8%', '10%', '12%', '14%', '16%', '18%', '20%', '22%', '24%', '26%', '28%', '30%']

interface AreaChartProps {
    npv: []
}
// @ts-ignore
const AreaChartDiscountRate = ( props: AreaChartProps ) => {
    return (
        <Line
            options={{...options, scales: {
                    y: {
                        max: roundUpToNearestRange( Math.max(...props.npv.slice(0, 16)) ),
                        min: roundUpToNearestRange( Math.min(...props.npv.slice(0, 16))*-1 )*-1
                    }
                }, layout: {
                    padding: {
                        top: 50,
                        right: 50,
                    }
                }
            }}
            data={{
                labels,
                datasets: [
                    {
                        fill: true,
                        label: 'NPV',
                        data: props.npv.slice(0, 16).map(elem => Math.round(elem*100)/100),
                        borderColor: 'rgba(251, 186, 0, 1)',
                        backgroundColor: 'rgba(251, 186, 0, 0.5)',
                        stack: 'stack1', // Set the same stack name for the second dataset
                        datalabels: {
                            display: false
                        }
                    },
                ],
            }}
        />
    );
};

export default AreaChartDiscountRate;